import { render, staticRenderFns } from "./StepBankCredentials.vue?vue&type=template&id=257b4006&scoped=true"
import script from "./StepBankCredentials.vue?vue&type=script&lang=js"
export * from "./StepBankCredentials.vue?vue&type=script&lang=js"
import style0 from "./StepBankCredentials.vue?vue&type=style&index=0&id=257b4006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257b4006",
  null
  
)

export default component.exports